import { Lightning, Settings } from '@lightningjs/sdk'

import { getColor, grey50, grey700, primary600 } from '../../constants/colors'
import { Images } from '../../constants/paths'
import { getAsset } from '../../utils/image'
import SpeechComp from '../speechComp/speechComp'
import { fullWidth, roundTo, verticallyCentered } from './utils'

const TRACK = {
  h: (h) => h / 5,
  ...fullWidth,
  ...verticallyCentered,
}

export default class ProgressBar extends SpeechComp {
  private _progress: number
  private _limit: number
  private _isLiveStream: boolean

  static _template() {
    return {
      collision: true,

      Background: {
        ...TRACK,
        rect: true,
        color: getColor(grey50),
        alpha: 0.3,
        zIndex: 1,
      },
      ProgressTrack: {
        ...TRACK,
        rect: true,
        color: getColor(grey50),
        alpha: 1,
        zIndex: 2,
      },
      Thumb: {
        ...verticallyCentered,
        mountX: 0.5,
        x: 0,
        texture: Lightning.Tools.getSvgTexture(getAsset(Images.PLAYER_THUMB), 56, 56),
        zIndex: 3,
        visible: false,
      },
    }
  }

  get background() {
    return this.tag('Background')
  }

  get progressTrack() {
    return this.tag('ProgressTrack')
  }

  get thumb() {
    return this.tag('Thumb')
  }

  get speechText(): string {
    return 'Progress Bar. Scroll to Seek'
  }

  set isLiveStream(v: boolean) {
    this._isLiveStream = v

    this.background.patch({ color: getColor(v ? grey700 : grey50), alpha: v ? 1 : 0.3 })
    this.progressTrack.patch({ color: getColor(v ? primary600 : grey50) })
  }

  get isLiveStream() {
    return this._isLiveStream ?? false
  }

  set limit(v) {
    this._limit = v
    this.redraw()
  }

  get limit() {
    return this._limit
  }

  set progress(v) {
    this._progress = this._isLiveStream ? v : v < 0 ? 0 : v > this._limit ? this._limit : v
    this.redraw()
  }

  get progress() {
    return this._progress
  }

  get step() {
    return this._limit * Settings.get('app', 'ui.seekRatio', 0.05)
  }

  _focus() {
    this.focusThumb(true)
    this.speak()
  }

  _unfocus() {
    this.focusThumb(false)
  }

  focusThumb(isFocused: boolean) {
    this.thumb.patch({
      visible: isFocused,
    })
  }

  redraw() {
    this.stage.update()
    const ratio = roundTo(this._progress / this._limit, 3)
    const position = this.finalW * ratio

    this.progressTrack.w = position
    this.thumb.x = position
  }

  _handleClick() {
    return false
  }
}
